module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_flower@2x-eb2ab051fbb4af9fcbb1af867ae46387.webp";